import styled from 'styled-components';

import { MiniBadge } from '@xing-com/badge';
import { Card as BaseCard } from '@xing-com/card';
import { SGapCol } from '@xing-com/crate-jobs-components-columns';
import { lineClamp } from '@xing-com/crate-utils-line-clamp';
import { mediaConfined } from '@xing-com/layout-tokens';
import { ProfileImage } from '@xing-com/profile-image';
import {
  spaceM,
  spaceS,
  spaceXS,
  xdlColorControlBorder,
} from '@xing-com/tokens';
import { BodyCopy, Headline, Meta } from '@xing-com/typography';

export const Card = styled(BaseCard)`
  height: 100%;

  &:hover,
  &:focus {
    border-color: ${xdlColorControlBorder};
  }

  & > div {
    height: 100%;
  }
`;

export const Article = styled.article`
  display: flex;
  height: 100%;
`;

export const TopRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;

  @media ${mediaConfined} {
    align-items: flex-start;
  }
`;

export const Image = styled(ProfileImage)`
  pointer-events: none;
`;

export const Date = styled(Meta)`
  display: flex;
  align-items: center;

  @media ${mediaConfined} {
    margin-bottom: auto;
  }
`;

export const Notification = styled(MiniBadge)`
  margin-right: ${spaceXS};
`;

export const Details = styled(SGapCol)`
  flex-grow: 1;
`;

export const Title = styled(Headline)`
  ${lineClamp(2)};
  word-break: break-word;
`;

export const City = styled(BodyCopy)`
  ${lineClamp(1)};
  word-break: break-all;
`;

export const Company = styled(BodyCopy)`
  ${lineClamp(1)};
  word-break: break-all;

  @media ${mediaConfined} {
    ${lineClamp(2)};
    word-break: break-word;
  }
`;

export const HeaderContainer = styled.div`
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  gap: ${spaceS};

  @media ${mediaConfined} {
    gap: ${spaceM};
  }
`;

export const EndRow = styled.div`
  display: flex;
  flex-direction: row;
  gap: ${spaceS};
  justify-content: space-between;
  align-items: center;

  @media ${mediaConfined} {
    flex-direction: column;
    align-items: normal;
  }
`;
